import { FontAwesomeIconsPartooUsed as e } from "@partoohub/ui";
import { NEWS_TYPE as a, ANNOUNCE_TYPE as s, HELP_TYPE as o, INFORMATION_TYPE as t } from "./NotificationPanel.types.js";
const r = [{
  dataTrackId: "",
  id: "1",
  message: "Répondre à vos avis prend trop de temps ? Pas de problème, utilisez nos messages suggérés par notre IA ✨",
  icon: [e.faWandMagicSparkles],
  date: "il y a 2h",
  product: "Messages",
  category: a
}, {
  dataTrackId: "",
  id: "2",
  message: "Vous en avez marre de répéter les mêmes informations ? Essayez les messages automatiques 😉",
  icon: [e.faHouse],
  date: "il y a 2h",
  product: "Messages",
  category: a
}, {
  dataTrackId: "",
  id: "3",
  message: "Communiquez avec plus de clients : Connectez votre compte WhatsApp",
  icon: [e.faBell],
  date: "il y a 2h",
  product: "Plateformes",
  category: a
}], n = [{
  dataTrackId: "",
  id: "1",
  // eslint-disable-next-line quotes
  message: "Nous venons de faire l'acquisition de Partoo food",
  icon: [e.faWandMagicSparkles],
  date: "il y a 2h",
  product: "Messages",
  category: s
}], c = [{
  dataTrackId: "",
  id: "1",
  // eslint-disable-next-line quotes
  message: "N'hésitez pas à aller voir nos tutoriel sur notre help center",
  icon: [e.faWandMagicSparkles],
  category: o
}], m = {
  type: t,
  items: [...r, ...n, ...c]
}, l = {
  items: [{
    dataTrackId: "",
    id: "1",
    message: "Le compte Instagram a été déconnecté.",
    icon: [e.faWarning],
    date: "il y a 2h",
    product: "Messages",
    platform: "instagram"
  }, {
    dataTrackId: "",
    id: "2",
    message: "Vous en avez marre de répéter les mêmes informations ? Essayez les messages automatiques 😉",
    icon: [e.faWarning],
    date: "il y a 2h",
    product: "Établissements",
    platform: "google"
  }, {
    dataTrackId: "",
    id: "3",
    message: "Communiquez avec plus de clients : Connectez votre compte WhatsApp",
    icon: [e.faWarning],
    date: "il y a 2h",
    product: "Messages",
    platform: "facebook"
  }]
}, p = {
  facebook: "Mettre à jour le mot de passe",
  instagram: "Reconnectez Instagram",
  google: "Reconnectez Google"
};
export {
  l as alerts,
  n as announces,
  c as help,
  m as informations,
  r as news,
  p as platformsButtonText
};
